var $d8c72262aeebb985$exports = {};
$d8c72262aeebb985$exports = {
    "endTime": `\u{7D50}\u{675F}\u{6642}\u{9593}`,
    "startTime": `\u{958B}\u{59CB}\u{6642}\u{9593}`,
    "time": `\u{6642}\u{9593}`
};


export {$d8c72262aeebb985$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
